import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MpSnackbarComponent } from './ui-components/mp-snackbar/mp-snackbar.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MpSnackbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
}
